import { createStore, createHook, type Action } from 'react-sweet-state';

interface State {
	isBlanketShown: boolean;
}

const initialState: State = {
	isBlanketShown: false,
};

const actions = {
	showBlanket:
		(): Action<State> =>
		({ setState }) =>
			setState({ isBlanketShown: true }),
	hideBlanket:
		(): Action<State> =>
		({ setState }) =>
			setState({ isBlanketShown: false }),
} as const;

type Actions = typeof actions;

const store = createStore<State, Actions>({
	name: 'confluence-loom-utils.loom-recorder-loading-blanket',
	initialState,
	actions,
});

export const useLoomRecorderLoadingBlanket = createHook(store);
